define(function() {
  class Settings {
    constructor() {
      this.$checkbox = $(".js-delete-checkbox");
      this.$deleteBtn = $(".js-delete-btn");
      this.$label = $(".js-delete-label");

      this.deleteAccount = this.deleteAccount.bind(this);

      this.bindEvents();
    }

    bindEvents() {
      this.$deleteBtn.on("click", this.deleteAccount);
    }

    deleteAccount(event) {
      const checked = this.$checkbox.is(":checked")

      if (!checked) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.$label.toggleClass("error error-shake", !checked);
    }
  }

  return Settings;
});
